const CheckTypes = {
	REQUIRE: 'REQUIRE',
	NUMBER: 'NUMBER',
	AMOUNT: 'AMOUNT',
	MOBILE: 'MOBILE',
	MAIL: 'MAIL',
	USER_DEFINED: 'USER_DEFINED'
}

export {
	CheckTypes
}